module.exports = __webpack_public_path__ + "static/img/5.42b68b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/sp/5.png
// module id = wPXI
// module chunks = 0